/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import { fixedBody, looseBody } from '@/utils/fn';
import styles from './index.less';

const CustomModal = ({
  title = '季度奖励获奖记录',
  children,
  okText = '知道了',
  okCallback = () => {},
  cancelCallback,
  visible = false,
  cancelText = '',
  needFixedBody = true,
}) => {
  const [innerVisibile, setInnerVisibile] = useState(visible);

  const innerCancelCallback = useCallback(() => {
    if (!cancelCallback || typeof cancelCallback !== 'function') {
      setInnerVisibile(false);
    } else {
      cancelCallback();
    }
  }, []);

  useEffect(() => {
    setInnerVisibile(visible);
    if (needFixedBody) {
      if (visible) {
        fixedBody();
      } else {
        looseBody();
      }
    }
  }, [needFixedBody, visible]);

  return (
    <div className={`${styles['custom-modal']} ${innerVisibile ? styles['show'] : styles['hide']}`}>
      <div className={styles['modal-content']}>
        {title && <h3 className={styles['modal-title']}>{title}</h3>}
        {children}
        <div className={`${styles['modal-btns']} ${cancelText ? styles['two-btns'] : ''}`}>
          {cancelText && (
            <button className={styles['cancel-btn']} onClick={innerCancelCallback}>
              {cancelText}
            </button>
          )}
          <button className={styles['ok-btn']} onClick={okCallback}>
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
};
export default CustomModal;
